const STORAGE_KEY = "cookie_consent";

export type ConsentValue = "accepted" | "declined";

export function getConsent(): ConsentValue | null {
  return localStorage.getItem(STORAGE_KEY) as ConsentValue | null;
}

export function setConsent(value: ConsentValue): void {
  localStorage.setItem(STORAGE_KEY, value);
  if (value === "accepted") {
    window.dispatchEvent(new CustomEvent("consent-granted"));
  }
}

export function hasConsented(): boolean {
  return getConsent() === "accepted";
}

export function resetConsent(): void {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent("reset-consent"));
}
